import { DateTime } from "luxon";

export const getFrequencyDescription = (jobEvent) => {
  if (!jobEvent?.frequency) return null;

  const { type, each, interval } = jobEvent.frequency;
  const start = DateTime.fromISO(jobEvent.startDate);
  const end = DateTime.fromISO(jobEvent.endDate);

  let text = "";

  if (type === "weekly") {
    const days = interval
      ?.map((d) => d.value.charAt(0).toUpperCase() + d.value.slice(1))
      ?.join(", ");
    text = `Every ${each > 1 ? `${each} weeks` : "week"} on ${days}`;
  } else if (type === "monthly") {
    text = `Every ${each > 1 ? `${each} months` : "month"}`;
  } else if (type === "daily") {
    text = `Every ${each > 1 ? `${each} days` : "day"}`;
  } else {
    text = type?.charAt(0).toUpperCase() + type?.slice(1) || "Single execution";
  }

  const endDateFormatted = end?.isValid ? end.toFormat("MMM dd, yyyy") : "unknown date";
  return `${text} until ${endDateFormatted}`;
};
